import { forwardRef, useCallback } from "react";
import { CheckBoxInput, Label, ErrorText, Div, InputWrapperDiv, HelperText } from "./checkbox.style";

const Checkbox = forwardRef(
    (
        {
            id,
            name,
            type = "checkbox",
            label,
            required,
            helperText,
            value,
            error,
            fullWidth,
            className,
            onChange,
            isMobile,
            ...remainingProps
        }, ref
    ) => {
        const labelId = label ? `${id}-label` : undefined;
        const errorId = error ? `${id}-error-text` : undefined;

        const handleChange = useCallback(
            (event) => {
                onChange(event);
            },
            [onChange]
        );

        return (
            <Div fullWidth={fullWidth} className={className}>

                <InputWrapperDiv>
                    <CheckBoxInput
                        id={id}
                        ref={ref}
                        name={name}
                        type={type}
                        value={value}
                        required={required}
                        aria-invalid={!!error}
                        aria-describedby={errorId}
                        onChange={handleChange}
                        error={error}
                        isMobile={isMobile}
                        {...remainingProps}
                    />
                    {label && (
                        <Label id={labelId} htmlFor={id}>
                            {`${label}${required ? "*" : ""}`}
                        </Label>
                    )}

                </InputWrapperDiv>
                {helperText && (
                    <HelperText>
                        {helperText}
                    </HelperText>
                )}

                {error && (
                    <ErrorText
                        initial="pageInitial"
                        animate="pageAnimate"
                        exit="pageExit"
                        variants={{
                            pageInitial: {
                                opacity: 1,
                                x: 0,
                                y: -5,
                            },
                            pageAnimate: {
                                opacity: 1,
                                x: 0,
                                y: 0,
                            },
                            pageExit: {
                                opacity: 0,
                            },
                        }}
                        id={errorId}
                    >
                        {error}
                    </ErrorText>
                )}
            </Div>
        )
    })

export { Checkbox }
